import { KioskConnectivityStatusBar } from '../../ui/components/pure/kiosk-connectivity/kiosk-connectivity-status-bar/kiosk-connectivity-status-bar.component';
import { useKioskConnectivityStatusBar } from './kiosk-connectivity-status-bar.hook';
import { kioskConnectivityStatusUpdatesToStatusBarProps } from './kiosk-connectivity-status-bar.map';

export function KioskConnectivityStatusBarContainer() {
  const kioskConnectivityStatusHookResult = useKioskConnectivityStatusBar();
  const props = kioskConnectivityStatusUpdatesToStatusBarProps(kioskConnectivityStatusHookResult);
  return props.statuses.length ? <KioskConnectivityStatusBar {...props} /> : null;
}
